import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Form } from '@mentimeter/ragnar-ui/form';
import { TextInput } from '@mentimeter/ragnar-ui/input/text-input';
import { Button } from '@mentimeter/ragnar-ui/button';
import { useTranslate } from '../../features/localization/translate';

const MAX_LENGTH = 200;

export const SubmitForm = ({
  onSubmitVote,
}: {
  onSubmitVote: (answer: string) => void;
}) => {
  const translate = useTranslate();

  const [answer, setAnswer] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);
  return (
    <Box alignItems="center">
      <Form
        width="100%"
        alignItems="center"
        onSubmit={(e) => {
          e.preventDefault();
          const cleanAnswer = answer.replace(/ +/g, ' ').trim();
          onSubmitVote(cleanAnswer);
          setSubmitted(true);
        }}
      >
        <TextInput
          mt="space8"
          name="quiz-open-input"
          disabled={submitted}
          maxLength={MAX_LENGTH}
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          required={true}
        />
        <Button
          size="large"
          mt="space6"
          type="submit"
          variant="primary"
          state={submitted ? 'loading' : undefined}
          disabled={submitted}
        >
          {translate('buttons.submit')}
        </Button>
      </Form>
    </Box>
  );
};
